import { render, staticRenderFns } from "./FattorinoList.vue?vue&type=template&id=1dcfad9b&"
import script from "./FattorinoList.vue?vue&type=script&lang=ts&"
export * from "./FattorinoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports